import React, {useState} from 'react';
import Header from "../../../layouts/Header";
import {IoSearchCircleOutline} from "react-icons/io5";
import debounce from 'lodash.debounce';
import {GiTwoCoins} from "react-icons/gi";
import {useNavigate} from "react-router-dom";

import {showError} from "../../../utils/toastHelper";
import {getLastSearches, getServices} from "../api/HomeApi";
import Loading from "../../../layouts/Loading";

import {VscHistory} from "react-icons/vsc";


const currencyFormat = Intl.NumberFormat('en-US');

function SearchProducts() {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [services, setServices] = React.useState([]);
    const [lastSearches, setLastSearches] = React.useState([]);
    const [term, setTerm] = React.useState('');



    React.useEffect(() => {
        const fetchLastSearch = async () => {
            const search = window.localStorage.getItem("searchTerm")
            setTerm(search);
            if (search && search.length > 2) {
                setLoading(true);
                const params = {
                    search
                }
                try {
                    const data = await getServices(params);
                    setServices(data.data);

                } catch (err) {
                    showError(err);
                } finally {
                    setLoading(false);
                }
            }

        };
        fetchLastSearch();

    }, []);

    React.useEffect(() => {
        const fetchLastSearches = async () => {

            const params = {
            }
            try {
                const data = await getLastSearches(params);
                setLastSearches(data.data[0]);

            } catch (err) {
                showError(err);
            } finally {
                setLoading(false);
            }

        };
        fetchLastSearches();

    }, []);

    const performSearch = async (searchTerm) => {
        if (searchTerm.length <= 2) {
            setServices([]);
            return;
        }

        setLoading(true);
        const params = {
            search: searchTerm,
            list: 1,
            orderType: 'desc',
            count: 20,
            platform: 'WebApp'
        };

        try {
            const data = await getServices(params);
            setServices(data.data);
        } catch (err) {
            showError(err);
        } finally {
            setLoading(false);
        }
    };

    const debouncedSearch = React.useMemo(() => debounce(performSearch, 500), []);

    // onChange ورودی
    const onInputChange = (e) => {
        const value = e.target.value;
        setTerm(value);
        debouncedSearch(value); // فقط وقتی کاربر مکث کرد، جستجو انجام میشه
    };


    if (loading) return <Loading />;

    return (
        <React.Fragment>

            <Header title='جستجوی کالا' hasBack={true}/>
            <section className="container  mt-3 py-5 rtl  ">
                <div className="row search-city mx-2">
                    <div className="col-12  border-secondary border-opacity-25">
                        <IoSearchCircleOutline className='text-secondary text-big-3'/>

                        <input
                            autoFocus
                            type="text" placeholder='جستجو در همه خدمات'
                            className='text-secondary text-small-1 pe-3 w-75 border-0 bg-transparent no-visible-border'
                            value={term}
                            onChange={onInputChange}
                        />
                    </div>

                </div>

                {
                    !services.length &&
                    <div className="row mx-1 mt-4 text-small-1">
                        <div className="col-12 home-separator-text ">
                            <VscHistory className='mx-2'/>
                            جستجوهای اخیر
                        </div>
                        <div className="col-12 ">
                            {
                                lastSearches.map(term => {
                                    return (
                                        <span
                                            className='badge text-big-1 rounded bg-secondary-subtle border-secondary text-dark mx-1 px-4 mt-3 py-2'
                                            onClick={() => {
                                                performSearch(term)
                                                setTerm(term)
                                            }}
                                        >
                                        {term}
                                    </span>
                                    )
                                })
                            }
                        </div>
                    </div>
                }


                {
                    !loading && services.map(service => {
                            const price = service.price * (1 - (service.discount_percent / 100))
                            return (
                                <div className="row my-2 service-search-card  mx-2 pt-2 px-0 " key={service.id}
                                     onClick={() => {
                                         window.localStorage.setItem("searchTerm", term);
                                         window.localStorage.setItem("fromSearch", 1);
                                         navigate(`/service/${service.id}`);
                                     }}
                                >
                                    <div className="col-3 border-bottom pb-3 ">
                                        <img src={service.image} alt={service.title} className='service-img'/>
                                    </div>
                                    <div className="col-9 fw-bolder text-muted border-bottom pb-3 ">

                                        {service.title}
                                        <div className='text-small-3 text-muted mt-2 fw-light text-justify'>
                                            {service.brief.substring(0,70)}
                                        </div>
                                        {service.price ?
                                            <div className='price-with-discount mt-3'>

                                                <GiTwoCoins className='ms-2 '/>
                                                {
                                                    service.discount_percent &&
                                                    <span
                                                        className='text-decoration-line-through fw-normal text-small-2 px-2 '>
                                                       {currencyFormat.format(service.price)}
                                                        &nbsp;
                                                        ریال
                                            </span>
                                                }
                                                {currencyFormat.format(price)}
                                                &nbsp;
                                                ریال
                                                &nbsp;

                                            </div> :
                                            <div className='text-small-2 text-muted'>
                                                <GiTwoCoins className='mx-2'/>
                                                توافقی
                                            </div>
                                        }
                                    </div>





                                </div>
                            );
                        }
                    )
                }
            </section>
        </React.Fragment>
    );
}

export default SearchProducts;